import Vue from 'vue'
import Router from 'vue-router'

/* const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
} */

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: () => import('@/pages/index.vue'),
    meta: {
      title: '首页'
    }
  },
    {
      path: '*',
      name: 'error',
      component: () => import('@/pages/error.vue'),
      meta: {
        title: '404 Not Found'
      }
    },
    {
      path: '/vip/dredge-vip',
      name: 'dredge',
      component: () => import('@/pages/vip/dredge-vip.vue'),
      meta: {
        title: '开通VIP'
      }
    },
    {
      path: '/academy/academy-list',
      name: 'academyList',
      component: () => import('@/pages/academy/academy-list.vue'),
      meta: {
        title: '院校大全'
      }
    },
    {
      path: '/academy/academy',
      name: 'academy',
      component: () => import('@/pages/academy/academy.vue'),
      meta: {
        title: '院校详情'
      }
    },
    {
      path: '/academy/academy-contrast',
      name: 'academyContrast',
      component: () => import('@/pages/academy/academy-contrast.vue'),
      meta: {
        title: '院校对比'
      }
    },
    {
      path: '/enroll/enroll',
      name: 'enroll',
      component: () => import('@/pages/enroll/enroll.vue'),
      meta: {
        title: '录取数据'
      }
    },
    {
      path: '/other/control',
      name: 'control',
      component: () => import('@/pages/other/control.vue'),
      meta: {
        title: '省控线'
      }
    },
    {
      path: '/other/subsection',
      name: 'subsection',
      component: () => import('@/pages/other/subsection.vue'),
      meta: {
        title: '一分一段表'
      }
    },
    {
      path: '/intelligent/recommend',
      name: 'recommend',
      component: () => import('@/pages/intelligent/recommend.vue'),
      meta: {
        title: '智能推荐'
      }
    },
    {
      path: '/other/level',
      name: 'level',
      component: () => import('@/pages/other/level.vue'),
      meta: {
        title: '学科水平'
      }
    },
    {
      path: '/other/grade',
      name: 'grade',
      component: () => import('@/pages/other/grade.vue'),
      meta: {
        title: '成绩分析'
      }
    },
    {
      path: '/volunteer/volunteer-page',
      name: 'volunteer-page',
      component: () => import('@/pages/volunteer/volunteer-page.vue'),
      meta: {
        title: '志愿填报-填报入口'
      }
    },
    {
      path: '/volunteer/volunteer',
      name: 'volunteer',
      component: () => import('@/pages/volunteer/volunteer.vue'),
      meta: {
        title: '志愿填报-志愿表'
      }
    },
    {
      path: '/volunteer/voluntary-report',
      name: 'voluntary-report',
      component: () => import('@/pages/volunteer/voluntary-report.vue'),
      meta: {
        title: '志愿报告'
      }
    },
    {
      path: '/probability/probability-entranc',
      name: 'probability-entranc',
      component: () => import('@/pages/probability/probability-entrance.vue'),
      meta: {
        title: '录取概率'
      }
    },
    {
      path: '/probability/probability',
      name: 'probability',
      component: () => import('@/pages/probability/probability.vue'),
      meta: {
        title: '录取概率'
      }
    },
    {
      path: '/majer/majer-list',
      name: 'majer-list',
      component: () => import('@/pages/majer/majer-list.vue'),
      meta: {
        title: '专业解读'
      }
    },
    {
      path: '/majer/majer',
      name: 'majer',
      component: () => import('@/pages/majer/majer.vue'),
      meta: {
        title: '专业解读'
      }
    },
    {
      path: '/occupation/occupation-list',
      name: 'occupation-list',
      component: () => import('@/pages/occupation/occupation-list.vue'),
      meta: {
        title: '职业大全'
      }
    },
    {
      path: '/occupation/occupation',
      name: 'occupation',
      component: () => import('@/pages/occupation/occupation.vue'),
      meta: {
        title: '职业大全'
      }
    },
    {
      path: '/personal/personal',
      name: 'personal',
      component: () => import('@/pages/personal/personal.vue'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/personal/assistance',
      name: 'assistance',
      component: () => import('@/pages/personal/assistance.vue'),
      meta: {
        title: '帮助'
      }
    },
    {
      path: '/diagnose/diagnose',
      name: 'diagnose',
      component: () => import('@/pages/diagnose/diagnose.vue'),
      meta: {
        title: '诊断考试'
      }
    },
    {
      path: '/diagnose/diagnose-entrance',
      name: 'diagnose-entrance',
      component: () => import('@/pages/diagnose/diagnose-entrance.vue'),
      meta: {
        title: '诊断考试'
      }
    },
    {
      path: '/test/test-list',
      name: 'test-list',
      component: () => import('@/pages/test/test-list.vue'),
      meta: {
        title: '学业测试'
      }
    },
    {
      path: '/test/test-intro',
      name: 'test-intro',
      component: () => import('@/pages/test/test-intro.vue'),
      meta: {
        title: '学业测试'
      }
    },
    {
      path: '/test/test-topic',
      name: 'test-topic',
      component: () => import('@/pages/test/test-topic.vue'),
      meta: {
        title: '学业测试'
      }
    },
    {
      path: '/test/test-report',
      name: 'test-report',
      component: () => import('@/pages/test/test-report.vue'),
      meta: {
        title: '学业测试'
      }
    },
    {
      path: '/article/article-list',
      name: 'article-list',
      component: () => import('@/pages/article/article-list.vue'),
      meta: {
        title: '文章列表'
      }
    },
    {
      path: '/article/article',
      name: 'article',
      component: () => import('@/pages/article/article.vue'),
      meta: {
        title: '文章详情'
      }
    },
    {
      path: '/other/advance',
      name: 'advance',
      component: () => import('@/pages/other/advance.vue'),
      meta: {
        title: '提前批'
      }
    },
    {
      path: '/other/advance-deta',
      name: 'advance',
      component: () => import('@/pages/other/advance-deta.vue'),
      meta: {
        title: '提前批院校详情'
      }
    },
    {
      path: '/other/sports',
      name: 'sports',
      component: () => import('@/pages/other/sports.vue'),
      meta: {
        title: '体育类'
      }
    },
    {
      path: '/other/art',
      name: 'art',
      component: () => import('@/pages/other/art.vue'),
      meta: {
        title: '艺术类'
      }
    },
    {
      path: '/newly/prior',
      name: 'prior',
      component: () => import('@/pages/newly/prior.vue'),
      meta: {
        title: '预科'
      }
    },
    {
      path: '/newly/special',
      name: 'special',
      component: () => import('@/pages/newly/special.vue'),
      meta: {
        title: '专项'
      }
    },
    {
      path: '/newly/strong-base',
      name: 'strong-base',
      component: () => import('@/pages/newly/strong-base.vue'),
      meta: {
        title: '强基院校'
      }
    },
    {
      path: '/newly/evaluate',
      name: 'evaluate',
      component: () => import('@/pages/newly/evaluate.vue'),
      meta: {
        title: '综合评价'
      }
    },
    {
      path: '/newly/evaluate-details',
      name: 'evaluate-details',
      component: () => import('@/pages/newly/evaluate-details.vue'),
      meta: {
        title: '综合评价'
      }
    },
    {
      path: '/not-open',
      name: 'not-open',
      component: () => import('@/pages/not-open.vue'),
      meta: {
        title: '暂未开放'
      }
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/pages/intro.vue'),
      meta: {
        title: '介绍'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else if (to.query.title) {
    document.title = decodeURIComponent(to.query.title)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js